export const INSPIRATIONS_LAST_PUBLISHED_DATE_KEY =
  'inspirations-last-published-date'

export const PPG_DALJAB_ENABLED_GROUP = 'ppg_daljab'
